import { AiFillFacebook, AiFillYoutube, AiFillInstagram } from "react-icons/ai";

export const menuList = [
    {
        id: 1,
        testo: "Home",
        url: "home"
    }, 
    {
        id: 2,
        testo: "Azienda",
        url: "azienda"
    },
    {
        id: 3,
        testo: "Qualità",
        url: "quality"
    },
    {
        id: 4,
        testo: "Servizi",
        url: "servizi"
    },
    // {
    //     id: 5,
    //     testo: "Realizzazioni",
    //     url: "realizzazioni"
    // },
    {
        id: 6,
        testo: "Contattaci",
        url: "contattaci"
    }
]

export const socialList = [
    {
        id: 1,
        social: "facebook",
        url: "#",
        icona: <AiFillFacebook />
    }, 
    {
        id: 1,
        social: "instagram",
        url: "#",
        icona: <AiFillInstagram />
    }, 
    {
        id: 1,
        social: "youtube",
        url: "#",
        icona: <AiFillYoutube />
    }, 
]
